import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { backendURL } from '../../data/config.json'

//Components
import Breadcrumb from '../../menus/FleetBreadcrum'
import Fleet from '../../components/Fleet'

const EconomicEn = props => (
  <div className="page  Economic">
  <Helmet
          title={` Economic Vehicles for Rent | Budget Nicaragua`}
          meta={[
            {
              name: 'description',
              content:
                'Frequently Asked Questions about car rentals. ',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'en',
              href:
                './es/fleet/economic',
            },
          ]}
        />
    <Breadcrumb
      lang={props.pathContext.langKey}
      currentPage={' Economic Cars'}
    />
    <h1> Economic</h1>
    <Fleet
      lang={props.pathContext.langKey}
      types={props.data.dataJson.fleetTypes}
      fleet={props.data.dataJson.fleet}
      features={props.data.dataJson.fleetFeatures}
      category={9}
    />
  </div>
)

export const query = graphql`
  query EconomicEN {
    dataJson(id: { regex: "/fleet/" }) {
      ...FleetData
    }
    allFile(filter: { relativeDirectory: { eq: "fleet" } }) {
      edges {
        node {
          name
          childImageSharp {
            resolutions {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
  }
`

export default EconomicEn



// WEBPACK FOOTER //
// ./src/pages/fleet/economic.en.js